import React, { ReactNode } from 'react';
import { Header } from './Header';
import { Breadcrumbs } from './Breadcrumbs';

interface PageLayoutProps {
  children: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  showBreadcrumbs?: boolean;
  className?: string;
}

const maxWidthClasses: Record<string, string> = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-5xl',
  xl: 'max-w-6xl',
  '2xl': 'max-w-7xl',
  full: 'max-w-full',
};

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = 'xl',
  showBreadcrumbs = true,
  className = '',
}) => {
  return (
    <div className="min-h-screen bg-spotify-black">
      <Header />

      <main className={`${maxWidthClasses[maxWidth]} mx-auto px-4 py-6 ${className}`}>
        {showBreadcrumbs && <Breadcrumbs />}
        {children}
      </main>

      <footer className="border-t border-gray-800 mt-16">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="text-center text-gray-500 text-sm">
            <p>Intelligent Spotify Player</p>
            <p className="mt-1 text-gray-600">Powered by 4.8 billion datapoints</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PageLayout;
